




import Vue from "vue"

export default Vue.extend({
  props: {
    errorMessage: {
      type: String,
      default: null,
    },
  },
})
